// Libs
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// Selectors
import { selectProfile } from 'screens/Login/selectors';
// Utils
import { getReactions, submitReaction } from './Reactions.utils';
// Components
import { LogoIcon, Popover, Rate } from 'components';
import ReactionButton from './ReactionButton';
// Skeleton
import ReactionsSkeleton from './ReactionsSkeleton';
// Styles
import styles from './Reactions.module.css';

const Reactions = ({
	// Props
	resourceKey,
	resourceId,
	externalReactionHandler = {},
}) => {
	const { extReactions, extSetted, setExtReactions } = externalReactionHandler; // This line provide external support with purpose prevent reloading by virtualization

	const [submittingReactionId, setSubmittingReactionId] = useState(-1);
	const [{ isFetching }, setState] = useState({
		isFetching: false,
	});
	const [localReactions, setLocalReactions] = useState(
		() => extReactions || [],
	);

	useEffect(() => {
		let isMounted = true;
		if (extSetted) return;

		setState(prev => ({ ...prev, isFetching: true }));
		getReactions({
			resourceKey,
			resourceId,
		}).then(data => {
			if (!isMounted) return; // avoid memory leaks
			const reactions = Array.isArray(data) ? data : [];
			if (setExtReactions)
				setExtReactions(prev => ({
					...prev,
					reactions,
					setted: true,
				}));
			else setLocalReactions(reactions);
			setState(prev => ({ ...prev, isFetching: false }));
		});

		return () => {
			isMounted = false;
		};
	}, [extSetted]);

	const handleSubmitReaction = async (reactionId, rating) => {
		setSubmittingReactionId(reactionId);
		const data = await submitReaction({
			resourceKey,
			resourceId,
			reactionId,
			rating,
		});
		if (!data) return;
		if (setExtReactions)
			setExtReactions(prev => ({
				...prev,
				setted: false,
			}));
		else setLocalReactions(data);
		setSubmittingReactionId(-1);
	};

	const isSubmitting = submittingReactionId !== -1;

	const reactions = React.useMemo(
		() => (extReactions?.length ? extReactions : localReactions),
		[extReactions, localReactions],
	);

	return (
		<>
			{!isFetching ? (
				reactions.map(({ reactionId, reactionKey, hasRating, count }) =>
					!hasRating ? (
						<ReactionButton
							key={reactionId}
							reactionKey={reactionKey}
							isLoading={reactionId === submittingReactionId}
							disabled={isSubmitting}
							count={count}
							resourceKey={resourceKey}
							resourceId={resourceId}
							onClick={() => handleSubmitReaction(reactionId)}
						/>
					) : (
						<Popover
							key={reactionId}
							title={null}
							trigger='click'
							content={
								<div className={styles.popoverContent}>
									<Rate
										disabled={isSubmitting}
										onChange={value => handleSubmitReaction(reactionId, value)}
										allowClear={true}
										allowHalf={true}
									/>
								</div>
							}
						>
							<ReactionButton
								reactionKey={reactionKey}
								isLoading={reactionId === submittingReactionId}
								disabled={isSubmitting}
								count={count}
								resourceKey={resourceKey}
								resourceId={resourceId}
							/>
						</Popover>
					),
				)
			) : (
				<LogoIcon spin={true} />
			)}
		</>
	);
};

const mapStateToProps = state => ({
	profile: selectProfile(state),
});

Reactions.Skeleton = ReactionsSkeleton;

export default connect(mapStateToProps, null)(Reactions);
